<template>
  <div class="blog-page">
    <b-loading :is-full-page="true" :active.sync="performingRequest" :can-cancel="true"></b-loading>
    <main>
      <section class="py-8 px-4">
        <div v-if="post" class="container">
          <span class="section-title text-left">
            <h1>{{ post.title }}</h1>
            <span class="flex items-center">
              <span
                class="post-author-pic"
                :style="{backgroundImage: `url('${post.author.picture || `https://ui-avatars.com/api/?size=512&background=386B61&color=fff&name=${post.author.name}+${post.author.lastName}`} ')` }"
              />
              <h3 class="m-0">
                <router-link
                  :to="`/profiles/${post.userId}`"
                  class="hover:underline"
                >{{post.author.name}} {{post.author.lastName}}</router-link>
                | {{ post.updatedOn||post.createdOn | formatDate }}
              </h3>
              <social-sharing
                :url="$route.query.page"
                :title="post.title"
                :quote="post.content | trimLength(50) "
                inline-template class="ml-auto">
                <div>
                  <b-icon icon="share-variant" class="text-green-800 mr-1 md:mr-2" />
                  <network network="twitter" class="ml-1 md:ml-2">
                    <a href="#">
                      <b-icon icon="twitter" />
                    </a>
                  </network>
                  <network network="facebook" class="ml-1 md:ml-2">
                    <a href="#">
                      <b-icon icon="facebook" />
                    </a>
                  </network>
                  <network network="linkedin" class="ml-1 md:ml-2">
                    <a href="#">
                      <b-icon icon="linkedin" />
                    </a>
                  </network>
                </div>
              </social-sharing>
            </span>
          </span>
          <span v-if="post.picture" class="w-full flex justify-center">
            <img :src="`${post.picture}`" class="mx-auto" />
          </span>

          <div class="post-content mt-8">
            <div v-html="post.content" />
          </div>
        </div>
      </section>

      <!-- Blog Section -->
      <section id="blog" class="content-section blog-posts alt-background">
        <div class="container">
          <span class="section-title">
            <h1 class="text-center md:text-left">Blog</h1>
            <h3>
              Confira o conteúdo publicado pelos profissionais
              <br />cadastrados em nosso site
            </h3>
          </span>
          <BlogPosts
            :showAuthor="true"
            classes="column is-one-third-desktop is-one-quarter-fullhd"
          />
        </div>
      </section>
      <!-- Nearby Professionals -->
      <ProfessionalsCarousel title="Profissionais Próximos" queryType="location" />
    </main>
  </div>
</template>
<script>
import BlogPosts from '@/components/BlogPosts'
import ProfessionalsCarousel from '@/components/ProfessionalsCarousel/ProfessionalsCarousel'
import moment from 'moment'
import { trimLengthMixin } from '../mixins/filters'
const fb = require('../firebaseConfig')
export default {
  mixins: [trimLengthMixin],
  components: {
    BlogPosts,
    ProfessionalsCarousel
  },
  data () {
    return {
      post: {},
      performingRequest: false
    }
  },
  methods: {
    getPost () {
      this.performingRequest = true
      const postId = this.$route.params.id
      fb.postsCollection
        .doc(postId)
        .get()
        .then(doc => {
          this.performingRequest = false
          this.post = doc.data()
        })
        .catch(err => {
          this.performingRequest = false
          console.log(err)
        })
    }
  },
  mounted () {
    this.getPost()
  },
  watch: {
    $route () {
      this.getPost()
    }
  },
  filters: {
    formatDate (val) {
      if (!val) {
        return '-'
      }
      const date = val.toDate()
      moment.locale('pt-BR')
      return moment(date).fromNow()
    }
  }
}
/**
 * @todo exibir carrossel de profissionais
 */
</script>
